import { MessageWrapper } from '../../messageWrapper/messageWrapper.module';
import { customCardData } from './customCard.model';
import { CustomCardTemplate } from './customCard.template';

export default class CustomCard {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = customCardData;
		this.setter({
			...propData,
		});
	}

	initWrapper() {
		this.html = new MessageWrapper({
			...this.data,
			innerHTML: CustomCardTemplate(this.data),
		});

		const { message_id } = this.data;
		this.contentDiv = document.createElement('div');
		this.contentDiv.id = `cardPreview_${message_id}`;
		this.contentDiv.className = 'card-preview-content';
		this.contentDiv.style.width = '95%';
		this.contentDiv.style.overflow = 'auto';

		const container = this.html.querySelector(`#engt-custom-card-node-container-id${message_id}`);
		if (container) {
			container.appendChild(this.contentDiv);
		}
	}

	initEventHandlers() {
		const { customCardContent = { html_content: '', css_content: '' } } = this.data;

		setTimeout(() => {
			const shadow = this.contentDiv.attachShadow({ mode: 'open' });
			const style = document.createElement('style');
			style.textContent = customCardContent.css_content;
			shadow.appendChild(style);
			shadow.innerHTML += customCardContent.html_content;
		}, 0);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
